import {
	Button,
	Dropdown,
	CustomSelectControl,
	SelectControl,
	TextControl,
} from "@wordpress/components";
import { PROVIDERQUERY } from "../helpers";
import { useImageContext } from "../context/ImageContext";
import { CustomNumberControl } from "./CustomNumberInput";
import { __ } from "@wordpress/i18n"
const QueryFilters = () => {
	const {
		provider: _provider,
		updateQueryParams,
		additionalQueryParams,
	} = useImageContext();

	const provider = _provider.toUpperCase();

	// Don't show filters for 'All' provider or if provider doesn't exist in PROVIDERQUERY
	if (provider === "All" || !PROVIDERQUERY[provider]) {
		return null;
	}

	const currentProviderParams = PROVIDERQUERY[provider];

	// Filter out the searchTerm parameter as it's handled separately
	const filterParams = Object.entries(currentProviderParams).filter(
		([key]) => key !== "searchTerm",
	);
	return (
		<>
			{!!filterParams.length && (
				<div className="image-hub-filters">
					{filterParams.map(([paramKey, paramConfig]) => (
						<div key={paramKey}>
							{paramConfig.acc_values ? (
								<SelectControl
									key={paramKey + "-select-control-" + _provider}
									style={{ minWidth: "180px" }}
									__next40pxDefaultSize
									__nextHasNoMarginBottom
									label={paramKey.replaceAll("_", " ") }
									value={
										additionalQueryParams?.[paramConfig?.name] ||
										paramConfig?.default
									}
									onChange={(value) =>
										updateQueryParams(paramKey, value)
									}
									options={[
										!paramConfig.acc_values.some(acv => acv.toLowerCase() == "all") ? {
											label: __('All', 'image-hub'),
											value: "",
										} : null,
										...paramConfig.acc_values.map(
											(value, idx) => ({
												label:
													paramConfig?.values_labels?.[idx] ||
														(value.charAt(0).toUpperCase() + value.slice(1)),
												value: value,
											}),
										),
									].filter(x => !!x)}
								/>
							) : paramConfig.type === "string" ? (
								<TextControl
									key={paramKey + "-text-control"}
									__next40pxDefaultSize
									__nextHasNoMarginBottom
									value={
										additionalQueryParams?.[paramConfig?.name] ||
										paramConfig?.default
									}
									placeholder="..."
									onChange={(value) =>
										updateQueryParams(
											paramConfig.name,
											value,
										)
									}
									label={paramKey.replaceAll("_", " ")}
								/>
							) : (
								<CustomNumberControl
									key={paramKey + "-custom-number-control"}
									value={
										additionalQueryParams?.[paramConfig?.name] ||
										paramConfig?.default
									}
									onChange={(value) =>
										updateQueryParams(
											paramConfig.name,
											value,
										)
									}
									label={paramKey
										.toUpperCase()
										.replaceAll("_", " ")}
								/>
							)}
						</div>
					))}
				</div>
			)}
		</>
	);
};

export default QueryFilters;
